module.exports = __webpack_public_path__ + "img/sorten.0301411c.jpg";